import useAPI from '@/hooks/useAPI';
import InsuranceRepository from '@/repositories/InsuranceRepository';

const useInsurancePlanTypes = (enabled = true) => {
  const insuranceRepository = InsuranceRepository();

  return useAPI({
    queryKey: ['getInsurancePlanTypes'],
    queryFn: async () => {
      return await insuranceRepository.getPlanTypes();
    },
    enabled
  });
};

export default useInsurancePlanTypes;
